<template>
  <v-card class="d-flex align-center justify-center leaderboard-card"
    style="padding: 0; border: none; box-shadow: none;">
    <v-container fluid style="padding-top: 0px;">
      <v-overlay class="register-overlay" :dark="false" absolute v-model="canIRegister" opacity="0.3">
        <v-btn icon rounded @click="canIRegister = false"><v-icon>fa-times</v-icon></v-btn>
        <TournamentRegisterCollapsed />
      </v-overlay>
      <v-row class="mt-7 mb-7 align-center" align="center" justify="center" v-if="false">
        <h2 class="topTen">{{ $t('title_Leaderboard', { topItemsCount: rankingTopItems }) }}</h2>
        <v-icon class="ml-3" medium>fa-trophy</v-icon>
      </v-row>
      <!-- Current Winners !-->
      <v-row align="center" justify="center" class="my-7 bubbles-container" v-if="false">
        <div class="mr-7 second-position position-bubble" v-if="activeParticipants[1]">
          <div class="d-flex justify-center">
            <v-avatar class="glassy-parent" size="70"
              :style="`border: 3px solid ${$store.state.tournament.tournamentSettings?.colors?.primary ? '#' + $store.state.tournament.tournamentSettings.colors.primary.replace('#', '') : '#000'} !important`">
              <v-img class="glassy-child"
                :src="activeParticipants[1].profilePicture !== null ? activeParticipants[1].profilePicture : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'" />
              <div v-if="$store.state.tournament.antiSpoiler" class="glassy-child glassy-circle" />
            </v-avatar>
          </div>
          <h4 class="text-center mt-2 mb-0">{{ $t('ranks.second') }}</h4>
          <p v-if="!$store.state.tournament.antiSpoiler" class="text-center mb-0">{{ username(activeParticipants[1]) }}
          </p>
        </div>
        <div v-if="activeParticipants[0]" class="first-position position-bubble">
          <v-avatar class="glassy-parent" size="100"
            :style="`border: 3px solid ${$store.state.tournament.tournamentSettings?.colors?.primary ? '#' + $store.state.tournament.tournamentSettings.colors.primary.replace('#', '') : '#000'} !important`">
            <v-img class="glassy-child"
              :src="activeParticipants[0].profilePicture !== null ? activeParticipants[0].profilePicture : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'" />
            <div v-if="$store.state.tournament.antiSpoiler" class="glassy-child glassy-circle" />
          </v-avatar>
          <div>
            <h4 class="text-center mt-2 mb-0">{{ $t('ranks.first') }}</h4>
            <p v-if="!$store.state.tournament.antiSpoiler" class="text-center mb-0">{{ username(activeParticipants[0])
              }}
            </p>
          </div>
        </div>
        <div class="ml-7 third-position position-bubble" v-if="activeParticipants[2]">
          <div class="d-flex justify-center">
            <v-avatar class="glassy-parent" size="70"
              :style="`border: 3px solid ${$store.state.tournament.tournamentSettings?.colors?.primary ? '#' + $store.state.tournament.tournamentSettings.colors.primary.replace('#', '') : '#000'} !important`">
              <v-img class="glassy-child"
                :src="activeParticipants[2].profilePicture !== null ? activeParticipants[2].profilePicture : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'" />
              <div v-if="$store.state.tournament.antiSpoiler" class="glassy-child glassy-circle" />
            </v-avatar>
          </div>
          <h4 class="text-center mt-2 mb-0">{{ $t('ranks.third') }}</h4>
          <p v-if="!$store.state.tournament.antiSpoiler" class="text-center mb-0">{{ username(activeParticipants[2]) }}
          </p>
        </div>
      </v-row>
      <v-row align="center" justify="center" class="px-0">
        <v-data-table v-if="false" style="width: 100%; background-color: transparent;" :items="activeParticipants"
          :headers="headers" :items-per-page="rankingTopItems" hide-default-footer>
          <template v-slot:item.rank="{ item }">
            <div class="d-flex align-center justify-start">
              <h4>{{ getRank(item) + 1 }}°</h4>
              <div v-if="item.previousPlace !== null && (getRank(item) + 1) !== item.previousPlace"
                class="d-flex align-center justify-start">
                <v-icon class="ml-2 mr-1" :color="(getRank(item) + 1 > item.previousPlace) ? 'error' : 'primary'"
                  x-small>
                  {{ (getRank(item) + 1 > item.previousPlace) ? 'fa-caret-down' : 'fa-caret-up' }}</v-icon>
                <p :style="`color: ${(getRank(item) + 1 > item.previousPlace) ? '#EF5350' : 'var(--v-mainGreen-base)'}`" class="my-0">{{
                  Math.abs((getRank(item) + 1) - item.previousPlace) }}</p>
              </div>
              <v-icon v-else-if="item.previousPlace !== null" class="ml-2" x-small>fa-grip-lines</v-icon>
            </div>
          </template>
          <template v-slot:item.image="{ item }">
            <div>
              <div class="glassy-child">
                <v-avatar size="35">
                  <v-img
                    :src="item.profilePicture !== null ? item.profilePicture : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'"></v-img>
                </v-avatar>
                <Flag class="ml-n2 mb-n3" v-if="countryCode(item) !== null" :code="countryCode(item)" size="S" />
              </div>
              <div v-if="$store.state.tournament.antiSpoiler" class="glassy-child glassy-card" />
            </div>
          </template>
          <template v-slot:item.firstName="{ item }">
            <div>
              <p class="glassy-child row-text">{{ capitalize(item.firstName) }}</p>
              <div v-if="$store.state.tournament.antiSpoiler" class="glassy-child glassy-card" />
            </div>
          </template>
          <template v-slot:item.username="{ item }">
            <div>
              <p class="glassy-child row-text">{{ username(item) }}</p>
              <div v-if="$store.state.tournament.antiSpoiler" class="glassy-child glassy-card" />
            </div>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip :color="$store.state.tournament.tournamentSettings?.colors?.primary ? '#' + $store.state.tournament.tournamentSettings.colors.primary.replace('#', '') : '#000'" small outlined>
              <p class="row-text">{{ capitalize(item.status) }}</p>
            </v-chip>
          </template>
          <template v-slot:item.score="{ item }">
            <div v-if="$store.state.tournament.antiSpoiler">
              <v-chip v-if="String($store.state.tournament.tournamentSettings.tournamentRankingType).includes('PERCENTAGE')" class="glassy-child"
                :color="$store.state.tournament.tournamentSettings?.colors?.primary ? '#' + $store.state.tournament.tournamentSettings.colors.primary.replace('#', '') : '#000'" text-color="white" small>
                <b>{{ (item.score != null) ? `${(item.score * 100).toFixed(2)}%` : '-' }}</b>
              </v-chip>
              <v-chip v-else :color="$store.state.tournament.tournamentSettings?.colors?.primary ? '#' + $store.state.tournament.tournamentSettings.colors.primary.replace('#', '') : '#000'" class="glassy-child"
                text-color="white" small>
                <b>{{ (item.score != null) ? item.score.toFixed(2) : '-' }}</b>
              </v-chip>
              <div class="glassy-child fit-glassy-card" />
            </div>
            <div v-else>
              <v-chip v-if="String($store.state.tournament.tournamentSettings.tournamentRankingType).includes('PERCENTAGE')"
                :color="$store.state.tournament.tournamentSettings?.colors?.primary ? '#' + $store.state.tournament.tournamentSettings.colors.primary.replace('#', '') : '#000'" small>
                <b>{{ (item.score != null) ? `${(item.score * 100).toFixed(2)}%` : '-' }}</b>
              </v-chip>
              <v-chip v-else :color="$store.state.tournament.tournamentSettings?.colors?.primary ? '#' + $store.state.tournament.tournamentSettings.colors.primary.replace('#', '') : '#000'" small>
                <b>{{ (item.score != null) ? item.score.toFixed(2) : '-' }}</b>
              </v-chip>
              <v-chip
                v-if="$store.state.tournament.secondRankingType === null && isWinningByMainRank(item) !== 'None' && !isMobile"
                class="ml-2" small>
                <p class="row-text">{{ $t('table.winning') }} <b class="row-text">{{ isWinningByMainRank(item) }}</b>
                </p>
                <v-icon color="green accent-3" class="ml-1" small>fa-medal</v-icon>
              </v-chip>
            </div>
          </template>
          <template v-if="!isMobile" v-slot:item.secondScore="{ item }">
            <v-chip v-if="item.score > $store.state.tournament.targetBalance" small><b>{{ (item.secondScore != null) ?
              item.secondScore.toFixed(2) : '-' }}</b></v-chip>
            <v-chip v-if="isWinningBySecondRank(item) !== 'None'" class="ml-2" small>
              {{ $t('table.winning') }} <b class="ml-1">{{ isWinningBySecondRank(item) }}</b>
              <v-icon color="green accent-3" class="ml-1" small>fa-medal</v-icon>
            </v-chip>
          </template>

        </v-data-table>
        <Table v-else :items="adminMode ? allParticipants : activeParticipants"
          :expandable="$store.state.tournament?.tournamentSettings?.publicPerformance === true || (currentParticipant && activeParticipants && activeParticipants.indexOf(currentParticipant) >= 0 && activeParticipants.indexOf(currentParticipant) < 3)"
          :blurred="$store.state.tournament?.antiSpoiler" :currentParticipant="currentParticipantComplete" :adminMode="adminMode"
          :tournamentEnded="tournamentEnded"
          @disqualify="$emit('disqualify', $event)"
          @activate="$emit('activate', $event)"
          @see-journal="$emit('see-journal', $event)"
          @send-email="$emit('send-email', $event)"
          :serverPagination="serverPagination"
          :serverTotalPages="serverTotalPages"
          :serverCurrentPage="serverCurrentPage"
          :serverTotalElements="serverTotalElements"
          :participantsLoading="participantsLoading"
          @page-change="$emit('page-change', $event)"
          @search-change="$emit('search-change', $event)"
          @download-members="$emit('download-members')"
          @add-participant="$emit('add-participant')" />
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import TournamentRegisterCollapsed from "@/views/Tournament/components/TournamentRegisterCollapsed";
import CountriesData from "@/views/Register/countries";
import Table from "../../../components/tournament-pos-table/Table.vue";

export default {
  name: "Leaderboard",
  components: { TournamentRegisterCollapsed, Table },
  props: {
    tournament: Object,
    iAmParticipant: Boolean,
    currentParticipant: Object,
    adminMode: Boolean,
    tournamentEnded: {
      type: Boolean,
      default: false,
    },
    serverPagination: {
      type: Boolean,
      default: false,
    },
    serverTotalPages: {
      type: Number,
      default: 1,
    },
    serverCurrentPage: {
      type: Number,
      default: 1,
    },
    serverTotalElements: {
      type: Number,
      default: 0,
    },
    participantsLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      itStarted: false,
      canIRegister: false,
      rankingTopItems: 10,
      secondScoreRank: [],
      activeParticipants: [],
      allParticipants: [],
      countries: CountriesData,
      currentParticipantComplete: undefined,
      headers: [
        { text: 'Rank', align: 'left', value: 'rank', sortable: false },
        { text: 'Profile', align: 'left', value: 'image', sortable: false },
        { text: 'First Name', align: 'left', value: 'firstName', sortable: false },
        { text: 'Username', align: 'left', value: 'username', sortable: false },
        { text: 'Status', align: 'left', value: 'status', sortable: false },
      ],
      isMobile: false
    };
  },
  created() {
    this.init();
    this.verifyCanIRegister();
  },
  mounted() {
    this.init();
    this.verifyCanIRegister();
    window.addEventListener("resize", () => {
      let mobile = window.innerWidth <= 1290 ? true : false;
      if (this.headers) {
        if (mobile) {
          this.headers = this.headers.filter(h => h.value !== 'image');
        } else {
          if (!this.headers.find(h => h.value == 'image'))
            this.headers.push({ text: this.$t('table.profile'), align: 'left', value: 'image', sortable: false });
        }
      }
      this.isMobile = mobile;
    });
  },
  watch: {
    '$store.state.tournament': function () {
      this.init();
      this.verifyCanIRegister();
    },
    iAmParticipant() {
      this.verifyCanIRegister();
    }
  },
  methods: {
    async init() {
      // In server-pagination mode, the source endpoint already returns the
      // correct slice for the current view: the public endpoint excludes
      // PAUSED/DISQUALIFIED for user mode, and the admin endpoint returns all
      // statuses for admin mode. Filtering client-side here was a leftover
      // from the pre-pagination era when the full roster sat in store, and
      // it caused user-mode pages to render partially (e.g. 3 rows on a page
      // of 10) when the page contained DQ'd entries.
      const storeParticipants = this.$store.state.tournament.participants;
      this.activeParticipants = this.serverPagination
        ? storeParticipants.slice()
        : storeParticipants.filter((participant) => participant.status === 'ACTIVE');
      this.allParticipants = storeParticipants.slice();
      this.verifyMockPositions();
      this.rankingTopItems = Math.max(10, this.$store.state.tournament.awards.length);
      let rankingHeader = this.$t(`table.rankTypes.${this.$store.state.tournament.tournamentSettings.tournamentRankingType}`);
      this.isMobile = window.innerWidth <= 1290 ? true : false;
      let adminUser;
      if (this.$store.state.tournament !== null && this.$store.state.clubMember !== null) {
        adminUser = this.$store.state.tournament.tournamentOrganizerId === this.$store.state.clubMember.club.id && (this.$store.state.clubMember.rol === 'FOUNDER') || (this.$store.state.clubMember.rol === 'ADMIN');
      }
      if (this.currentParticipant) {
        this.currentParticipantComplete = {
          ...this.currentParticipant,
          isAdmin: adminUser,
        }
      }
      if (!this.isMobile) {
        this.headers = [
          { text: this.$t('table.rank'), align: 'left', value: 'rank', sortable: false },
          { text: this.$t('table.profile'), align: 'left', value: 'image', sortable: false },
          { text: this.$t('table.firstName'), align: 'left', value: 'firstName', sortable: false },
          { text: this.$t('table.username'), align: 'left', value: 'username', sortable: false },
          ...(adminUser ? [{ text: this.$t('table.brokerAccountId'), align: 'left', value: 'brokerAccountIdentifier', sortable: false }] : []),
        ];
      } else {
        this.headers = [
          { text: this.$t('table.rank'), align: 'left', value: 'rank', sortable: false },
          { text: this.$t('table.firstName'), align: 'left', value: 'firstName', sortable: false },
          { text: this.$t('table.username'), align: 'left', value: 'username', sortable: false },
        ];
      }
      this.headers.push({ text: rankingHeader, value: 'score', sortable: false });

      if (this.$store.state.tournament.tournamentOrganizerId === 54) // TODO Change after Impulse Tournament finished
        this.headers = this.headers.filter((item) => item.value !== 'firstName');

      if (this.$store.state.tournament.secondRankingType !== undefined && this.$store.state.tournament.secondRankingType !== null) {
        this.computeSecondRank();
        this.headers.push({ text: this.$t('table.second.GROSS_LOSS'), value: 'secondScore', sortable: false });
      }
    },
    verifyMockPositions() {
      // Skip mock positions in server pagination mode — server controls the data
      if (this.serverPagination) return;
      let currentParticipants = this.$store.state.tournament.participants.length;
      if (this.$store.state.tournament.awards.length > currentParticipants) {
        let mockLength = this.$store.state.tournament.awards.length - currentParticipants;
        for (let i = 0; i < mockLength; i++)
          this.activeParticipants.push({
            profilePicture: null,
            firstName: '---',
            lastName: '---',
            username: '---',
            score: null,
            previousPlace: null,
          });
      }
    },
    verifyCanIRegister() {
      let startTime = new Date(this.$store.state.tournament.startTime);
      startTime.setDate(startTime.getDate()); // Condition to be added in db-model
      this.itStarted = startTime < new Date();
      //Next line will be added to allow users to join even if tournament has started but it still be in a date range
      const diffTime = Math.abs(new Date() - startTime);
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      let betweenDateRange = diffDays <= 7 && this.$store.state.tournament.tournamentId == 185;
      let visibility = this.$store.state.tournament.tournamentVisibility;
      let isClubMember = this.$store.state.clubMember !== null && this.$store.state.tournament.tournamentOrganizerId === this.$store.state.clubMember.club.id;
      this.canIRegister = !this.adminMode && (!this.itStarted || betweenDateRange) && !this.iAmParticipant && (visibility === 'PUBLIC' || (visibility === 'PRIVATE' && isClubMember));
    },
    getRank(participant) {
      return this.activeParticipants.indexOf(participant);
    },
    computeSecondRank() {
      let participantsSortBySecondRank = this.activeParticipants.slice();
      participantsSortBySecondRank = participantsSortBySecondRank.filter((a) => a.secondScore !== null && a.score > this.$store.state.tournament.targetBalance);
      participantsSortBySecondRank.sort((a, b) => (a.secondScore < b.secondScore) ? 1 : (a.secondScore > b.secondScore) ? -1 : 0);

      participantsSortBySecondRank.forEach((participant) => {
        this.secondScoreRank.push(participant.participantId);
      });
    },
    isWinningByMainRank(participant) {
      let foundAward = this.$store.state.tournament.awards.find((award) => award.rank === (this.getRank(participant) + 1));
      return (foundAward !== undefined) ? foundAward.title : 'None';
    },
    isWinningBySecondRank(participant) {
      let winning = 'None';
      this.$store.state.tournament.awards.forEach((award) => {
        if (participant.participantId === this.secondScoreRank[award.rank - 1])
          winning = award.title;
      });
      return winning;
    },
    countryCode(participant) {
      let countryFound = this.countries.find((country) => country.name === participant.country);
      return (countryFound !== undefined) ? countryFound.code : null;
    },
    username(participant) {
      let usernameSplit = String(participant.username).split('@');
      return usernameSplit[0];
    },
    veryFirstName(participant) {
      return this.capitalize(String(participant.firstName).split(' ')[0]);
    },
    capitalize(string) {
      let arr = string.split(" ");
      for (let i = 0; i < arr.length; i++)
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
      return arr.join(" ");
    },
  }
}
</script>

<style lang="scss">
@import "src/global";


.leaderboard-card {
  background-color: transparent !important;
  color: var(--v-mainBlack-base) !important;

  .glassy-child {
    position: relative;
  }

  .bubbles-container {
    @media (max-width: 768px) {
      position: relative;
      margin-top: 80px !important;
      margin-bottom: 120px !important;
    }

    .position-bubble {
      display: flex;
      flex-direction: column;
      align-items: center;

      @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;

        h4 {
          font-weight: bold !important;
        }

        &.first-position {
          p {
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:hover {
              overflow: visible;
              position: relative;
              background-color: var(--v-mainWhite-base);
              box-shadow: 0 0 4px 0 black;
              border-radius: 1px;
              width: fit-content;
              max-width: unset;
            }
          }
        }

        &.second-position {
          left: 0;
          top: -5px;
          padding-left: 16px;

          p {
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:hover {
              overflow: visible;
              position: relative;
              background-color: var(--v-mainWhite-base);
              box-shadow: 0 0 4px 0 black;
              border-radius: 1px;
              width: fit-content;
              max-width: unset;
            }
          }
        }

        &.third-position {
          right: 0;
          top: -5px;
          overflow: visible;
          padding-right: 16px;

          p {
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:hover {
              overflow: visible;
              position: relative;
              background-color: var(--v-mainWhite-base);
              box-shadow: 0 0 4px 0 black;
              border-radius: 1px;
              width: fit-content;
              max-width: unset;
            }
          }
        }

        .glassy-parent {
          width: 50px !important;
          height: 50px !important;
          min-width: unset !important;
        }
      }
    }
  }

  h2 {
    @media (max-width: 1290px) {
      &.topTen {
        font-size: 24px !important;
        font-weight: bold;
      }
    }
  }

  .register-overlay {
    .v-btn {
      position: absolute;
      z-index: 10;
      right: 0;
      margin: 20px;
      background-color: transparent !important;

      &:hover {
        color: var(--v-mainBlack-base) !important;
        background-color: transparent !important;
        box-shadow: none !important;

        &::before {
          background-color: transparent !important;
        }

        i {
          color: var(--v-mainBlack-base) !important;
        }
      }

      .v-icon {
        &:hover {
          color: var(--v-mainBlack-base) !important;
          background-color: transparent !important;
        }
      }
    }
  }
}

.avatar-special {
  border: 3px solid var(--v-darkGreen-base) !important;
}

.row-text {
  font-size: 14px !important;
  margin-bottom: 0;
}

.flag-text {
  z-index: 100 !important;
  font-size: 14px !important;
  margin-bottom: -5px;
  margin-top: -10px;
  margin-left: 30px;
}

.glassy-parent {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.glassy-child {
  position: absolute;
}

.glassy-card {
  z-index: 2;
  top: 0;
  left: 0;
  width: 125%;
  height: 100%;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(2.8px);
  -webkit-backdrop-filter: blur(2.8px);
}

.fit-glassy-card {
  z-index: 5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(2.8px);
  -webkit-backdrop-filter: blur(2.8px);
}

.glassy-circle {
  border-radius: 100px 100px 100px 100px !important;
  z-index: 2;
  top: 0;
  left: 0;
  width: 140%;
  height: 100%;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(2.8px);
  -webkit-backdrop-filter: blur(2.8px);
}
</style>


